import { C as ComponentHeader, d as defineCustomElement$1 } from './p-8bfe5ab0.js';
const OwcComponentHeader = ComponentHeader;
const defineCustomElement = defineCustomElement$1;
export { OwcComponentHeader, defineCustomElement };